var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppleStoreMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.046 20.275c-.98.95-2.05.8-3.08.35-1.09-.46-2.089-.48-3.239 0-1.44.62-2.2.44-3.059-.35C2.79 15.246 3.51 7.698 9.048 7.398c1.35.07 2.29.74 3.079.8 1.18-.24 2.31-.93 3.57-.84 1.509.12 2.649.72 3.398 1.8-3.119 1.87-2.38 5.978.48 7.128-.57 1.39-1.32 2.76-2.54 3.989h.01zM12.027 7.248c-.15-2.23 1.66-4.069 3.74-4.249.29 2.58-2.34 4.5-3.74 4.25z",
    fill: "#fff"
  })));
}

export default SvgAppleStoreMark;